export default __webpack_public_path__ + "static/media/misc-books4-768w.d2671d66.webp";